import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  locale: localStorage.getItem('elttec-locale') || 'zh'
}

const mutations = {
  SET_LOCALE(state, locale) {
    state.locale = locale
    localStorage.setItem('elttec-locale', locale)
  }
}

const actions = {
  toggleLocale({ commit, state }) {
    const next = state.locale === 'zh' ? 'en' : 'zh'
    commit('SET_LOCALE', next)
  },
  setLocale({ commit }, locale) {
    commit('SET_LOCALE', locale)
  }
}

const getters = {
  locale: state => state.locale,
  isZh: state => state.locale === 'zh',
  t: state => (key) => {
    const keys = key.split('.')
    let val = messages[state.locale]
    for (const k of keys) {
      if (val && val[k] !== undefined) val = val[k]
      else return key
    }
    return val
  }
}

const messages = {
  zh: {
    nav: {
      title: 'ELTTEC',
      home: '首页',
      products: '产品中心',
      about: '关于我们',
      demo: '预约演示',
      digital: '数字自动化'
    },
    hero: {
      badge: 'AI赋能 · 精益数字化转型',
      title: '智能数字化解决方案',
      subtitle: '专注航运服务管理系统 · 企业运营系统 · 流程自动化机器人 · 数字智能产线集成',
      desc: '融合 AI 技术，为航运服务及制造企业提供一站式数字化服务，助力企业实现精益数字化转型。覆盖从智能报价、生产执行到流程自动化和数字智能产线集成的全链路业务场景。',
      cta1: '预约演示',
      cta2: '产品中心',
      cta1Link: 'https://mom.elttec.com',
      stat1: '25+',
      stat1Label: '数智化经验',
      stat2: '60+',
      stat2Label: '软件著作权/专利',
      stat3: '3',
      stat3Label: '核心产品线',
      stat4: '7x24',
      stat4Label: '技术支持服务'
    },
    products: {
      title: '产品中心',
      subtitle: 'Product Center',
      desc: '三大核心产品线，覆盖企业运营全场景的智能化解决方案',
      intro: '覆盖企业运营全场景的智能化解决方案',
      ssms: {
        name: 'AI SSP',
        subtitle: '航运服务管理系统',
        desc: '人工智能驱动的航运服务与供应链管理平台，覆盖报价、采购、货物追踪、单船核算等全业务流程',
        icon: '🚢',
        features: ['人工智能报价引擎', '智能采购管理与协同', '销采供结算全程追踪可视化', '智能供应链优化', '批次仓储精准管理', '单船成本核算分析', '智能报表与数据大屏', '移动端实时同步办公'],
        detail: 'AI SSP 航运服务管理系统专为航运服务企业打造，以航运报价为起点，贯穿采购、货物追踪、仓储到单船核算的全链条数字化管理。系统融合 AI 智能算法，实现报价精准预测、供应链动态优化与经营数据实时洞察。',
        detailItems: [
          { title: '人工智能报价引擎', desc: '基于AI算法，将历史报价数据、销售基准价格和采购基准价格进行多维建模，自动生成船舶物资及部件的报价方案。通过机器学习与规则引擎的深度融合，实现从询价输入到报价方案输出的自动化闭环。' },
          { title: '智能采购管理与协同', desc: '从采购计划编制、供应商选择、订单下发、生产/发货跟踪到到货验收的全流程闭环，并通过供应商协同门户实现采购部门与供应商之间的在线协同与进度共享。通过流程数字化与协同在线化系统性地解决过程痛点。' },
          { title: '销采供结算全程追踪可视化', desc: '贯穿「销售订单建立→采购计划生成→采购订单下发/本地仓库发货→物流运输→到货交付→验收入库→结算对账」的完整业务链条，以可视化方式实时展示每个环节的进度状态，并对异常状态进行自动预警。通过业务状态机与可视化引擎实现全链路透明化。' },
          { title: '智能供应链优化', desc: '通过库存周转率分析、交期分析与需求预测建模，对补货策略、安全库存、仓储布局进行持续优化，在保障供应可用性的前提下降低缺货风险与库存积压风险。通过数据驱动的方式系统性优化供应链决策。'},
          { title: '批次仓储精准管理', desc: '按批次对入库物资进行精准编码与库位管理，支持批次溯源、效期管控及先进先出（FIFO）策略执行。在船舶物资供应场景中，仓储管理具有批次管理需求强（同一物资不同批次的供应商、采购价格、生产日期、认证证书可能不同）、效期管控严格（油漆涂料、化学品、橡胶密封件等有保质期要求，过期物资不可使用）、溯源要求高（船级社要求物资可追溯到具体批次与供应商）、库位管理复杂（大型设备、管材、板材等不规则物资的库位规划特殊）等特点，本模块通过批次维度的精细化管控满足上述需求。' },
          { title: '单船成本核算分析', desc: '以单船为核算单元，归集与该船相关的所有物资采购成本、部件加工成本、服务费用及相关附属费用，生成单船成本明细与销售实绩对比分析报告，为单船项目盈亏分析、报价优化与成本控制提供数据支撑。在船舶供应业务中，每艘船的供应需求是一个独立的项目（涉及数十至数百项物资与服务、跨越数周的供应周期、多笔采购与调拨），以单船为维度进行成本归集与分析，是实现项目级精细化管理的必要手段。' },
          { title: '智能报表与数据大屏', desc: '汇总销售、采购、库存、附属费用及成本等全维度业务数据，生成可视化报表与实时数据大屏，为管理层提供全局视角的业务洞察与决策依据。在船舶供应业务中，管理层需要实时掌握销售业绩、采购执行、库存健康、成本利润等核心指标的全局状况与趋势变化，传统报表模式下数据分散、时效滞后、维度单一，本模块通过统一数据仓库与可视化引擎，实现数据实时汇聚与多维可视化呈现。' },
          { title: '移动端实时同步办公', desc: '提供移动端审批、查询及任务处理功能，确保业务人员在外勤、出差或船上作业时可实时同步办公数据，实现随时随地办公。在船舶物资供应业务中，业务人员的工作场景高度移动化——采购员需在供应商现场考察、验收员需在码头/船厂验货、项目经理需在船上协调物资供应、管理层需在外出差时审批决策，传统PC端办公模式无法满足移动办公需求，将核心业务功能延伸至移动场景。' }
        ]
      },
      eom: {
        name: 'AI EOM',
        subtitle: '企业运营管理系统',
        desc: '集集团管理、ERP、SCM、MES、WMS于一体的综合运营管理平台，实现企业全业务流程数字化与智能化',
        icon: '🏭',
        features: ['多组织集团管控', 'ERP 企业资源计划', 'SCM 供应链管理','MES 生产制造执行', 'WMS 仓储物流管理', 'HR 人力资源管理', 'BI 商业智能分析', '质量全流程管控' ],
        detail: 'AI EOM 企业运营管理系统以流程驱动为核心，打通企业"人、机、料、法、环"各环节数据。支持多语言、多币种、多组织架构，可灵活选择云端或本地部署，实现从订单到交付的全链路数字化管理。',
        detailItems:  [
          { title: '多组织集团管控', desc: '支持多法人、多账簿、多组织架构的统一管理，实现集团财务业务一体化管控与合规运营' },
          { title: 'ERP 企业资源计划', desc: '以财务为核心，贯穿采购、销售、库存、生产、成本核算全链条，打通业财数据壁垒' },
          { title: 'SCM 供应链管理', desc: '覆盖供应商全生命周期管理与采购协同，实现需求→寻源→合同→交付→结算的闭环管理' },
          { title: 'MES 生产制造执行', desc: '实时采集车间生产数据，精准调度工序、人员、设备与物料，提升生产透明度和执行效率' },
          { title: 'WMS 仓储物流管理', desc: '精细化库位管理与条码追溯，支持多仓协同、出入库动态调度与库存智能预警' },
          { title: 'HR 人力资源管理', desc: '覆盖组织架构、招聘、考勤、薪酬、培训、绩效等核心人事管理模块，驱动人才数据一体化' },
          { title: 'BI 商业智能分析', desc: '多维度数据建模与可视化分析看板，实时监控经营指标，辅助高层科学决策' },
          { title: '质量全流程管控', desc: '覆盖来料检验、过程抽检、成品检验与不合格品处理的全流程质量追溯闭环' }
        ]
      },
      rpa: {
        name: 'AI RPA',
        subtitle: '流程自动化机器人',
        desc: '基于 AI+RPA 技术的智能流程自动化平台，实现跨系统业务流程自动执行，7×24 无人值守高效运行',
        icon: '🤖',
        features: ['桌面流程录制', '可视化流程编辑器', 'OCR 智能识别', '跨系统数据采集', '智能报表生成', '跨平台数据同步', 'AI 辅助决策', '7×24 无人值守'],
        detail: 'AI RPA 流程自动化机器人面向财务、人力、采购、IT 运维等场景，通过模拟人工操作实现跨系统、跨平台的自动化流程执行。内置 AI 能力，支持非结构化数据的智能识别、提取与处理。',
        detailItems: [
          { title: '财务自动化', desc: '自动完成发票验证、报销审核、银企对账等财务流程' },
          { title: 'HR 自动化', desc: '入职办理、考勤统计、薪资核算等 HR 流程自动化处理' },
          { title: '供应链自动化', desc: '订单处理、库存同步、供应商对账等流程智能执行' },
          { title: '跨系统同步', desc: '打通 CRM、ERP、OA 等系统数据壁垒，实现业务数据实时同步' }
        ]
      },
      dauto: {
        name: 'DAuto 数字自动化产线集成',
        subtitle: 'Digital-Automation Integration',
        desc: '以MOM制造运营管理为核心，深度融合产线自动化技术，打通订单到交付的全链路数据流，实现"计划—执行—反馈"闭环管理',
        features: ['MOM 数字化制造运营', '产线自动化建设改造', 'IT-OT 数自联动', '工业物联网数据采集', '数字孪生与仿真', '智能仓储物流集成'],
        detail: 'DAuto 数字自动化产线集成方案覆盖MOM数字化制造运营、产线自动化建设改造、IT-OT数自联动三大核心领域，构建从企业管理系统（ERP/PLM）到MOM运营平台、再到设备自动化层（SCADA/PLC/CNC/机器人）的纵向一体化架构。通过指令级数据互通与实时反馈闭环，打破管理层与执行层的信息壁垒，实现生产过程可视化、质量全程可追溯、设备状态实时可控。',
        detailItems: [
          { title: '设备互联与数据采集', desc: '支持PLC/CNC/SCADA/机器人/传感器等多源设备接入，毫秒级实时数据采集' },
          { title: '生产流程自动化控制', desc: '可视化流程编排驱动产线自动执行，覆盖投料→加工→检测→包装全工位' },
          { title: 'IT-OT 深度融合', desc: 'ERP/MOM管理层直连设备控制层，计划指令直达产线，执行数据实时回传' },
          { title: '全生命周期可追溯', desc: '物料→工艺→设备→人员全链路关联，任意环节可正向追溯与反向定位' },
          { title: '柔性制造与快速切换', desc: '支持多品种小批量混线生产，工艺参数一键切换，换线时间大幅缩减' },
          { title: '智能决策与实时优化', desc: 'AI引擎分析生产数据，动态调优工艺参数、排程策略与设备利用率' }
        ]
      }
    },
    stats: {
      title: '核心实力',
      subtitle: '用数据说话',
      cards: [
        { value: '2013', label: '公司成立' },
        { value: '70+', label: '软著 / 专利' },
        { value: '25+', label: '年数智化深耕' },
        { value: '高企/双软', label: '资质认证' }
      ]
    },
    about: {
      title: '关于我们',
      subtitle: 'About Us',
      titleText: '苏州易伦特信息科技有限公司',
      desc1: '苏州易伦特信息科技有限公司（ELTTEC）成立于 2013 年，深耕数智化领域 25 年以上，是一家专注于企业数字化转型的高新技术企业。公司主要从事计算机软件和人工智能(AI)应用的设计、研发、技术咨询与服务，承接网络工程设计、施工及技术服务，以及计算机系统集成等业务。',
      desc2: '公司汇聚 6 SIGMA 黑带大师和丰田制造精益管理大师，拥有 18+ 年MES开发实施经验和 20+ 年SAP实施经验，累计获得 70+ 项软件著作权及专利认证。',
      highlight1: '成立年份',
      highlight1Val: '2013',
      highlight2: '数智化深耕',
      highlight2Val: '25+年',
      highlight3: '软著/专利',
      highlight3Val: '70+',
      highlight4: '资质认证',
      highlight4Val: '高企/双软'
    },
    whyUs: {
      title: '为什么选择易伦特',
      subtitle: 'Why Choose Us',
      desc: '以专业团队和成熟方案为核心，为您的数字化转型保驾护航',
      cards: [
        {
          title: '专业团队',
          desc: '5名 6 SIGMA 黑带大师和丰田制造精益管理大师，10余名资深开发人员，技术实力雄厚'
        },
        {
          title: '成熟方案',
          desc: '18年以上 MES 开发实施经验，20余年 SAP 实施经验，打造经过验证的成熟解决方案'
        },
        {
          title: '完善服务',
          desc: '覆盖咨询、实施到运维的全生命周期服务，7×24小时技术支持保障'
        },
        {
          title: '技术创新',
          desc: '融合物联网、大数据、云计算、AI 等前沿技术，持续投入研发创新'
        },
        {
          title: '行业定制',
          desc: '深入理解航运、制造等行业，提供贴合业务实际的定制化解决方案'
        },
        {
          title: '安全可靠',
          desc: '企业级安全架构，数据加密传输与存储，权限分级管控，保障信息安全'
        }
      ]
    },
    cta: {
      title: '开启您的数字化转型之旅',
      desc: '无论产品演示、方案咨询还是技术评估，我们的专家团队随时为您服务',
      demoBtn: '预约免费演示',
      contactBtn: '联系我们',
      demoLink: 'https://mom.elttec.com'
    },
    footer: {
      brand: 'ELTTEC 易伦特科技',
      desc: '苏州易伦特信息科技有限公司 — 智能数字化解决方案专家，专注航运服务管理与制造企业数字化转型。',
      productsTitle: '产品中心',
      productLinks: {
        ssms: 'AI SSP 航运服务管理',
        eom: 'AI EOM 企业运营管理',
        rpa: 'AI RPA 流程自动化',
        dauto: 'DAuto 数字自动化产线集成'
      },
      contactTitle: '联系我们',
      phone: '电话：186-6229-2976',
      email: '邮箱：jufe.xie@elttec.com',
      address: '地址：江苏省苏州市唯华路3号',
      copyright: `© 2013-${new Date().getFullYear()} 苏州易伦特信息科技有限公司. All rights reserved.`,
      icp: '苏ICP备14019719号'
    }
  },
  en: {
    nav: {
      title: 'ELTTEC',
      home: 'Home',
      products: 'Products',
      about: 'About',
      demo: 'Request Demo',
      digital: 'Digital Automation'
    },
    hero: {
      badge: 'AI-Powered · Lean Digital Transformation',
      title: 'Intelligent Digital Solutions',
      subtitle: 'Shipping Service Management · Enterprise Operations · Robotic Process Automation · Digital Intelligent Production Line Integration',
      desc: 'Integrating AI technology, we provide one-stop digital services for shipping service and manufacturing enterprises, facilitating their lean digital transformation. Our solutions cover the entire business process from intelligent quotation and production execution to process automation and digital smart production line integration.',
      cta1: 'Request Demo',
      cta2: 'Our Products',
      cta1Link: 'https://mom.elttec.com',
      stat1: '25+',
      stat1Label: 'Years in Digitalization',
      stat2: '70+',
      stat2Label: 'Software Copyrights / Patents',
      stat3: '3',
      stat3Label: 'Core Product Lines',
      stat4: '7x24',
      stat4Label: 'Technical Support'
    },
    products: {
      title: 'Product Center',
      subtitle: 'Product Center',
      desc: 'Three core product lines, intelligent solutions covering the entire enterprise operational landscape',
      intro: 'Intelligent Solutions for Enterprise Operations',
      ssms: {
        name: 'AI SSP',
        subtitle: 'Shipping Service Management System',
        desc: 'AI-powered shipping service and supply chain management platform, covering quotation, procurement, cargo tracking, single-vessel accounting and other full business processes.',
        icon: '🚢',
        features: ['AI Quotation Engine', 'Smart Procurement Management & Collaboration', 'End-to-End Sales-Procurement-Supply Settlement Tracking', 'Smart Supply Chain Optimization', 'Batch Warehouse Precision Management', 'Single-Vessel Cost Accounting & Analysis', 'Smart Reports & Data Dashboard', 'Mobile Real-Time Synchronized Office'],
        detail: 'AI SSP is purpose-built for shipping service enterprises. Starting from shipping quotation, it spans procurement, cargo tracking, warehousing, and single-vessel accounting for full-chain digital management. The system integrates AI intelligent algorithms to achieve precise quotation prediction, dynamic supply chain optimization, and real-time business insights.',
        detailItems: [
          { title: 'AI Quotation Engine', desc: 'Based on AI algorithms, performs multi-dimensional modeling of historical quotation data, sales baseline prices, and procurement baseline prices to automatically generate quotation proposals for marine supplies and components. Through deep integration of machine learning and rule engines, it achieves an automated closed loop from inquiry input to quotation output.' },
          { title: 'Smart Procurement Management & Collaboration', desc: 'From procurement planning, supplier selection, order issuance, production/shipment tracking to receiving inspection, the entire process is managed in a closed loop. Through a supplier collaboration portal, online collaboration and progress sharing between procurement departments and suppliers are enabled. Process digitalization and collaboration online-ization systematically address procedural pain points.' },
          { title: 'End-to-End Sales-Procurement-Supply Settlement Tracking', desc: 'Covering the complete business chain of "sales order creation → procurement plan generation → purchase order issuance/local warehouse shipment → logistics transportation → delivery & receiving → inspection & warehousing → settlement & reconciliation", each step\'s progress status is displayed visually in real time, with automatic alerts for abnormal conditions. Full-chain transparency is achieved through the business state machine and visualization engine.' },
          { title: 'Smart Supply Chain Optimization', desc: 'Through inventory turnover analysis, lead time analysis, and demand forecasting modeling, replenishment strategies, safety stock levels, and warehouse layouts are continuously optimized — reducing both stockout risk and inventory overstock risk while ensuring supply availability. Supply chain decisions are systematically optimized through a data-driven approach.' },
          { title: 'Batch Warehouse Precision Management', desc: 'Inbound materials are precisely coded and managed by batch with bin location tracking, supporting batch traceability, shelf-life control, and FIFO strategy execution. In marine supply scenarios, warehouse management faces strong batch management requirements (the same material from different batches may differ in supplier, purchase price, production date, and certification), strict shelf-life control (paint, chemicals, rubber seals, etc. have shelf-life requirements — expired materials cannot be used), high traceability demands (classification societies require materials to be traceable to specific batches and suppliers), and complex bin management (irregular items such as large equipment, pipes, and plates require special storage planning). This module addresses all of the above requirements through batch-level fine-grained control.' },
          { title: 'Single-Vessel Cost Accounting & Analysis', desc: 'Taking each vessel as the accounting unit, all material procurement costs, component processing costs, service fees, and related ancillary expenses for that vessel are aggregated to generate single-vessel cost breakdowns and sales performance comparison reports, providing data support for per-vessel project profit/loss analysis, quotation optimization, and cost control. In marine supply operations, each vessel\'s supply requirement is an independent project (involving dozens to hundreds of materials and services, spanning weeks of supply cycles, and multiple purchases and transfers). Cost aggregation and analysis at the single-vessel level is the necessary approach for project-level lean management.' },
          { title: 'Smart Reports & Data Dashboard', desc: 'Aggregates full-dimension business data including sales, procurement, inventory, ancillary expenses, and costs to generate visual reports and real-time data dashboards, providing management with a comprehensive view of business insights and decision support. In marine supply operations, management needs real-time visibility into the overall status and trends of core metrics such as sales performance, procurement execution, inventory health, and cost/profit. Traditional reporting models suffer from data fragmentation, time-lagged updates, and single-dimensional views. This module, through a unified data warehouse and visualization engine, achieves real-time data aggregation and multi-dimensional visual presentation.' },
          { title: 'Mobile Real-Time Synchronized Office', desc: 'Provides mobile approval, query, and task processing functions, ensuring that business personnel can synchronize office data in real time during field visits, business trips, or onboard operations — enabling work anytime, anywhere. In marine material supply operations, work scenarios are highly mobile — procurement staff need to conduct supplier site inspections, receiving inspectors need to verify goods at docks/shipyards, project managers need to coordinate material supply on board, and management needs to approve decisions while traveling. Traditional PC-only office models cannot meet mobile work demands — this module extends core business functions to mobile scenarios.' }
        ]
      },
      eom: {
        name: 'AI EOM',
        subtitle: 'Enterprise Operations Management',
        desc: 'Integrated operations platform combining group management, ERP, SCM, MES, and WMS for full business process digitalization and intelligence.',
        icon: '🏭',
            features: ['Multi-entity Group Control',
                'ERP Resource Planning',
                'SCM Supply Chain Mgmt', 'MES Production Execution',
                'WMS Warehouse Management',
                'HR Management',
              'BI Business Intelligence',
              'Full Quality Control'
        ],
        detail: 'AI EOM is process-centric, connecting data across people, machines, materials, methods, and environment. Supporting multi-language, multi-currency, and multi-org structures with flexible cloud or on-premise deployment for end-to-end digital management.',
        detailItems: [
          { title: 'Multi-entity Group Control', desc: 'Unified governance across multiple legal entities, charts of accounts, and organizational structures for integrated financial-business operations and compliance.' },
          { title: 'ERP Resource Planning', desc: 'Finance-centric platform connecting procurement, sales, inventory, production, and cost accounting to eliminate business-finance data silos.' },
          { title: 'SCM Supply Chain Mgmt', desc: 'Full supplier lifecycle management with closed-loop procurement from demand, sourcing, and contracting through to delivery and settlement.' },
          { title: 'MES Production Execution', desc: 'Real-time workshop data collection with precise scheduling of workstations, personnel, equipment, and materials for transparent, efficient execution.' },
          { title: 'WMS Warehouse Management', desc: 'Granular bin management with barcode traceability, multi-warehouse coordination, dynamic inbound/outbound dispatch, and intelligent inventory alerts.' },
          { title: 'HR Management', desc: 'Comprehensive HR modules covering org structure, recruitment, attendance, payroll, training, and performance — unifying talent data end-to-end.' },
          { title: 'BI Business Intelligence', desc: 'Multi-dimensional data modeling with visual analytics dashboards for real-time KPI monitoring and data-driven executive decision-making.' },
          { title: 'Full Quality Control', desc: 'End-to-end quality traceability covering incoming inspection, in-process sampling, final inspection, and nonconformance handling.' }
        ]
      },
      rpa: {
        name: 'AI RPA',
        subtitle: 'Robotic Process Automation',
        desc: 'AI+RPA intelligent automation platform enabling cross-system automated execution of business processes with 24/7 unattended operation.',
        icon: '🤖',
        features: ['Desktop Recording', 'Visual Process Editor', 'OCR Recognition', 'Cross-system Data Capture', 'Automated Reporting', 'Cross-platform Sync', 'AI-assisted Decisions', '24/7 Unattended'],
        detail: 'AI RPA targets finance, HR, procurement, and IT operations, automating cross-system processes by simulating human operations. Built-in AI capabilities enable intelligent recognition, extraction, and processing of unstructured data.',
        detailItems: [
          { title: 'Finance Automation', desc: 'Automated invoice verification, expense approval, and bank reconciliation.' },
          { title: 'HR Automation', desc: 'Onboarding, attendance, and payroll automation.' },
          { title: 'Supply Chain Automation', desc: 'Intelligent order processing, inventory sync, and supplier reconciliation.' },
          { title: 'Cross-system Sync', desc: 'Breaking CRM, ERP, OA data silos for real-time business data synchronization.' }
        ]
      },
      dauto: {
        name: 'DAuto Digital-Automation Integration',
        subtitle: 'Digital-Automation Integration',
        desc: 'Centered on MOM manufacturing operations management, deeply integrating production line automation to build a closed-loop "Plan → Execute → Feedback" system across the entire order-to-delivery chain.',
        features: ['MOM Digital Manufacturing', 'Production Line Automation', 'IT-OT Convergence', 'IIoT Data Collection', 'Digital Twin & Simulation', 'Smart Logistics Integration'],
        detail: 'The DAuto Digital-Automation Integration solution spans three core domains — MOM digital manufacturing operations, production line automation retrofit, and IT-OT convergence — constructing a vertically integrated architecture from enterprise systems (ERP/PLM) through the MOM operations platform to the equipment automation layer (SCADA/PLC/CNC/robotics). Through command-level data interoperability and real-time closed-loop feedback, it eliminates the information barrier between management and execution layers, delivering full-process visibility, end-to-end quality traceability, and real-time equipment control.',
        detailItems: [
          { title: 'Device Connectivity & Data Collection', desc: 'Multi-source access for PLC/CNC/SCADA/robots/sensors with millisecond-level real-time acquisition.' },
          { title: 'Automated Process Control', desc: 'Visual orchestration drives line auto-execution across loading, processing, inspection, and packaging stations.' },
          { title: 'Deep IT-OT Convergence', desc: 'ERP/MOM management layer directly connected to device control layer — plans reach the line and execution data streams back in real time.' },
          { title: 'Full Lifecycle Traceability', desc: 'Material, process, equipment, and personnel fully linked — forward and reverse traceability at any point.' },
          { title: 'Flexible Manufacturing & Rapid Changeover', desc: 'Multi-variety low-volume mixed-line production with one-click recipe switching and drastically reduced changeover time.' },
          { title: 'Intelligent Decision & Real-time Optimization', desc: 'AI engine analyzes production data to dynamically optimize process parameters, scheduling strategies, and equipment utilization.' }
        ]
      }
    },
    stats: {
      title: 'Core Strengths',
      subtitle: 'Data-Driven',
      cards: [
        { value: '2013', label: 'Founded' },
        { value: '70+', label: 'Copyrights / Patents' },
        { value: '25+', label: 'Expertise Years' },
        { value: 'High-Tech', label: 'Certification' }
      ]
    },
    about: {
      title: 'About Us',
      subtitle: 'About Us',
      titleText: 'Suzhou ELTTEC Technology Co., Ltd.',
      desc1: 'Founded in 2013 with 25+ years of digitalization expertise, ELTTEC is a high-tech enterprise focused on enterprise digital transformation and AI applications. The company specializes in software design, development, technical consulting, network engineering, and system integration.',
      desc2: 'Our team includes 6 SIGMA Black Belt Masters and Toyota Lean Manufacturing experts, with 18+ years of MES experience and 20+ years of SAP implementation. We hold 70+ software copyrights and patent certifications.',
      highlight1: 'Founded',
      highlight1Val: '2013',
      highlight2: 'Digitalization',
      highlight2Val: '25+',
      highlight3: 'Copyrights/Patents',
      highlight3Val: '70+',
      highlight4: 'Certification',
      highlight4Val: 'High-Tech'
    },
    whyUs: {
      title: 'Why Choose ELTTEC',
      subtitle: 'Why Choose Us',
      desc: 'Professional teams and proven solutions at the core of your digital transformation journey.',
      cards: [
        {
          title: 'Expert Team',
          desc: '5 Six Sigma Black Belt Masters and Toyota Lean experts, plus 10+ senior developers with deep technical expertise.'
        },
        {
          title: 'Proven Solutions',
          desc: '18+ years of MES experience, 20+ years of SAP implementation, delivering battle-tested mature solutions.'
        },
        {
          title: 'Complete Service',
          desc: 'Full lifecycle coverage from consulting and implementation to operations, with 24/7 technical support.'
        },
        {
          title: 'Tech Innovation',
          desc: 'Integrating IoT, big data, cloud computing, and AI — continuously investing in R&D innovation.'
        },
        {
          title: 'Industry Customization',
          desc: 'Deep understanding of shipping and manufacturing industries, delivering tailored solutions.'
        },
        {
          title: 'Security & Reliability',
          desc: 'Enterprise-grade security architecture with encrypted transmission, storage, and role-based access control.'
        }
      ]
    },
    cta: {
      title: 'Start Your Digital Transformation',
      desc: 'Whether product demo, solution consultation, or technical evaluation — our expert team is ready to serve.',
      demoBtn: 'Free Demo',
      contactBtn: 'Contact Us',
      demoLink: 'https://mom.elttec.com'
    },
    footer: {
      brand: 'ELTTEC Technology',
      desc: 'Suzhou ELTTEC Technology Co., Ltd. — Expert in intelligent digital solutions for shipping service management and manufacturing digital transformation.',
      productsTitle: 'Products',
      productLinks: {
        ssms: 'AI SSP Shipping',
        eom: 'AI EOM Operations',
        rpa: 'AI RPA Automation',
        dauto: 'DAuto Integration'
      },
      contactTitle: 'Contact Us',
      phone: 'Tel: 186-6229-2976',
      email: 'Email: jufe.xie@elttec.com',
      address: 'Address: Weihua Road 3,Suzhou, Jiangsu',
      copyright: `© 2013-${new Date().getFullYear()} Suzhou ELunt Technology Co., Ltd. All rights reserved.`,
      icp: 'SU ICP No. 14019719'
    }
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
